import React from "react";
import "./gradient-background.scss";

/**
 * GradientBackground - A fixed positioned background component
 * that applies gradient backgrounds based on the current theme mode.
 *
 * Just provides the gradient background layer (z-index: 0).
 * SVG waves and blur orbs are in a separate GradientEffects component
 * that renders inside AppLayout to avoid z-index stacking context issues.
 */
const GradientBackground: React.FC = () => {
  return <div className="gradient-background-wrapper" aria-hidden="true" />;
};

export default GradientBackground;
